import React, { useState } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { getTrackBySlug, getMoreFromArtist, getYouMightAlsoLike } from "../trackCatalog";
import useTrackPlayer from "../hooks/useTrackPlayer";
import TrackPlayer from "../components/track/TrackPlayer";
import TrackGrid from "../components/track/TrackGrid";

export default function TrackDetail() {
  const { slug } = useParams();
  const track = getTrackBySlug(slug);

  // Hooks must run unconditionally, so guard the catalog lookup after calling them
  // and fall back to a stable placeholder track when there's no match yet.
  const player = useTrackPlayer(track || { id: 0, durationSeconds: 1, waveform: [] });
  const [added, setAdded] = useState(false);

  if (!track) {
    return <Navigate to="/music" replace />;
  }

  const moreFromArtist = getMoreFromArtist(track);
  const youMightAlsoLike = getYouMightAlsoLike(track, moreFromArtist);

  return (
    <>
      <section className="track-hero">
        <div className="container">
          <nav className="track-breadcrumb">
            <Link to="/music">Music</Link>
            <span>/</span>
            <Link to="/music">{track.genre}</Link>
            <span>/</span>
            <span className="current">{track.title}</span>
          </nav>

          <div className="row g-4 align-items-center">
            <div className="col-md-5 col-lg-4">
              <div className="track-cover">
                <img src={track.img} alt={track.title} />
                <div className="vinyl">
                  <div className="vinyl-disc"></div>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <span className="track-genre-badge-static">{track.genre}</span>
              <h1 className="track-hero-title">{track.title}</h1>
              <div className="track-hero-artist">
                <img src={track.artistAvatar} alt={track.artist} />
                <span>{track.artist}</span>
              </div>
              <p className="track-hero-desc">{track.description}</p>
              <div className="d-flex gap-3 flex-wrap">
                <button className="btn-mu-solid" onClick={player.toggle}>
                  {player.isPlaying ? "❚❚ Pause Track" : "▶ Play Track"}
                </button>
                <button
                  className="btn-mu-outline"
                  disabled={added}
                  onClick={() => setAdded(true)}
                >
                  {added ? "✓ Added to Playlist" : "+ Add to Playlist"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <TrackPlayer
          track={track}
          isPlaying={player.isPlaying}
          currentTime={player.currentTime}
          onToggle={player.toggle}
          onSeek={player.seekTo}
        />

        <div className="track-meta-card">
          <div>
            <div className="track-meta-label">Genre</div>
            <div className="track-meta-value">{track.genre}</div>
          </div>
          <div>
            <div className="track-meta-label">Release Date</div>
            <div className="track-meta-value">{track.releaseDate}</div>
          </div>
          <div>
            <div className="track-meta-label">Label</div>
            <div className="track-meta-value">{track.label}</div>
          </div>
          <div>
            <div className="track-meta-label">Duration</div>
            <div className="track-meta-value">{track.duration}</div>
          </div>
        </div>
      </div>

      <TrackGrid title={`More From ${track.artist}`} tracks={moreFromArtist} />
      <TrackGrid title="You Might Also Like" tracks={youMightAlsoLike} variant="lavender" />
    </>
  );
}
